import { render, staticRenderFns } from "./RiderCategoryIndex.vue?vue&type=template&id=4b803ba8&lang=pug"
import script from "./RiderCategoryIndex.vue?vue&type=script&lang=js"
export * from "./RiderCategoryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports